module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av549-3539295156c7a014d7afe5f2ec0580ab.jpg";